var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncluded(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "included") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    fill: "#CAE2CB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9957 22C17.4667 22 22 17.4734 22 12C22 6.52659 17.458 2 11.9869 2C6.5207 2 2 6.52659 2 12C2 17.4734 6.52941 22 11.9957 22ZM11.9957 20.5272C7.27809 20.5272 3.48562 16.7283 3.48562 12C3.48562 7.27167 7.26938 3.47276 11.9869 3.47276C16.7132 3.47276 20.5192 7.27167 20.5192 12C20.5192 16.7283 16.7219 20.5272 11.9957 20.5272ZM10.9222 16.6963C11.206 16.6963 11.4432 16.5586 11.6234 16.2952L16.285 8.97748C16.3847 8.80893 16.4883 8.61125 16.4883 8.42137C16.4883 8.03771 16.1484 7.7808 15.7784 7.7808C15.5547 7.7808 15.3357 7.91361 15.1681 8.17229L10.8834 15.0071L8.76649 12.3342C8.55538 12.0581 8.36168 11.9853 8.12142 11.9853C7.74663 11.9853 7.44631 12.2867 7.44631 12.6782C7.44631 12.8672 7.52769 13.0562 7.64781 13.2238L10.1774 16.2952C10.4011 16.58 10.6257 16.6963 10.9222 16.6963Z",
    fill: "#007505"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncluded);
export default __webpack_public_path__ + "static/media/included.267b2e18616190c76da70c440eb99130.svg";
export { ForwardRef as ReactComponent };